import CommunicationAnalytics from './CommunicationAnalytics';

export default CommunicationAnalytics;
